module.exports = __webpack_public_path__ + "static/img/mysz.ccb41e48.webp";